<div class="wrapper-detail-list">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a routerLink="/dashboard/knowledge-base" class="btn btn-back" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Knowledgebase' | translate">{{ "Knowledgebase" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-main container-fluid">
    <div class="row">
      <div class="col-xl-7 xl-60" *ngIf="article === 'article1'">
        <div class="blog-single">
          <div class="blog-box blog-details">
            <img
              class="img-fluid w-100"
              src="assets/sample-img2.jpg"
              alt="blog-main"
            />
            <div class="blog-details">
              <ul class="blog-social">
                <li class="digits">19 {{ "October" | translate }} 2022</li>
                <li>
                  <i class="fi fi-rs-user pr-2"></i>{{ "Admin" | translate }}
                </li>
                <li class="digits">{{ "General" | translate }}</li>
                <li class="digits">
                  <i class="fi fi-rr-clock-nine"></i>1 {{ "min" | translate }}
                </li>
                <!-- <li class="digits"><i class="fi fi-rr-social-network pr-2"></i>02<span>Hits</span></li> -->
                <!-- <li class="digits"><i class="fi fi-rr-comments pr-2"></i>598 Comments</li> -->
              </ul>
              <h4>
                {{
                  "What is eStore? - The Complete Guide to Your Shopping Experience."
                    | translate
                }}
              </h4>
              <div class="single-blog-content-top">
                <p>
                  {{
                    "eStore is an e-commerce platform by Wellous that specializes in acquiring, redeeming, and selling products digitally. The demand for digital stores and payments has become much higher than ever before. To meet this demand, the team has come up with a new way to engage with customers all over the world to create beautiful online stores without programmers and designers."
                      | translate
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- <section class="comment-box">
                <h4>Comment</h4>
                <hr>
                <ul>
                    <li>
                    <div class="media align-self-center"><img class="align-self-center" src="assets/comment.jpg"
                        alt="Generic placeholder image">
                        <div class="media-body">
                        <div class="row">
                            <div class="col-md-4 xl-100">
                            <h6 class="mt-0">Jolio Mark<span> ( Designer )</span></h6>
                            </div>
                            <div class="col-md-8 xl-100">
                            <ul class="comment-social float-start float-md-end learning-comment">
                                <li class="digits"><i class="fi fi-rr-social-network"></i>02 Hits</li>
                                <li class="digits"><i class="fi fi-rr-comments"></i>598 Comments</li>
                            </ul>
                            </div>
                        </div>
                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered
                            alteration in some form, by injected humour, or randomised words which don't look even slightly
                            believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't
                            anything embarrassing hidden in the middle of text.</p>
                        </div>
                    </div>
                    </li>
                    <li>
                    <ul>
                        <li>
                        <div class="media"><img class="align-self-center" src="assets/comment.jpg"
                            alt="Generic placeholder image">
                            <div class="media-body">
                            <div class="row">
                                <div class="col-xl-12">
                                <h6 class="mt-0">Jolio Mark<span> ( Designer )</span></h6>
                                </div>
                            </div>
                            <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered
                                alteration in some form, by injected humour, or randomised words which don't look even slightly
                                believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't
                                anything embarrassing hidden in the middle of text.</p>
                            </div>
                        </div>
                        </li>
                    </ul>
                    </li>
                    <li>
                    <div class="media"><img class="align-self-center" src="assets/comment.jpg"
                        alt="Generic placeholder image">
                        <div class="media-body">
                        <div class="row">
                            <div class="col-md-4 xl-100">
                            <h6 class="mt-0">Jolio Mark<span> ( Designer )</span></h6>
                            </div>
                            <div class="col-md-8 xl-100">
                            <ul class="comment-social float-start float-md-end learning-comment">
                                <li class="digits"><i class="fi fi-rr-social-network"></i>02 Hits</li>
                                <li class="digits"><i class="fi fi-rr-comments"></i>598 Comments</li>
                            </ul>
                            </div>
                        </div>
                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered
                            alteration in some form, by injected humour, or randomised words which don't look even slightly
                            believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't
                            anything embarrassing hidden in the middle of text.</p>
                        </div>
                    </div>
                    </li>
                </ul>
                </section> -->
        </div>
      </div>
      <div class="col-xl-7 xl-60" *ngIf="article === 'article2'">
        <div class="blog-single">
          <div class="blog-box blog-details">
            <img
              class="img-fluid w-100"
              src="assets/sample-img4.jpg"
              alt="blog-main"
            />
            <div class="blog-details">
              <ul class="blog-social">
                <li class="digits">03 {{ "November" | translate }} 2022</li>
                <li>
                  <i class="fi fi-rs-user pr-2"></i>{{ "Admin" | translate }}
                </li>
                <li class="digits">{{ "Payment" | translate }}</li>
                <li class="digits">
                  <i class="fi fi-rr-clock-nine"></i>15 {{ "min" | translate }}
                </li>
                <!-- <li class="digits"><i class="fi fi-rr-social-network pr-2"></i>02<span>Hits</span></li> -->
                <!-- <li class="digits"><i class="fi fi-rr-comments pr-2"></i>598 Comments</li> -->
              </ul>
              <h4>
                {{
                  "Setting up a Cash on Delivery (COD) Payment Method."
                    | translate
                }}
              </h4>
              <div class="single-blog-content-top">
                <b
                  ><p>
                    {{
                      "Enable cash on delivery in your eStore dashboard:"
                        | translate
                    }}
                  </p></b
                >
                <p>
                  {{
                    "1. From your eStore dashboard, go to 'Preferences'."
                      | translate
                  }}<br />
                  {{
                    "2. Click on the “Payments” tab and click the button to enable the Cash on Delivery Payment Method. That’s it. Now customers that live within the specified area can select the Cash on Delivery Payment Method when they check out."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-60"
                  src="assets/cod-1.png"
                  alt="blog-main"
                />
                <br />
                <p>
                  <b> {{ "How Cash on Delivery Works:" | translate }}</b>
                </p>
                <img
                  class="img-fluid w-100"
                  src="assets/cod-2.jpg"
                  alt="blog-main"
                />
                <p>
                  <b>{{ "Customer:" | translate }}</b
                  ><br />
                  {{
                    "1. During the checkout, the customer will choose the Cash on Delivery payment method."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100"
                  src="assets/cod-3.png"
                  alt="blog-main"
                />
                <p>
                  {{
                    "2. Click “Place Order” to proceed to the payment page."
                      | translate
                  }}<br />
                  {{
                    "3. Redirect the customer to the “Thank You” page. The customer will receive an email notification that the order is pending for your approval."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100"
                  src="assets/cod-4.png"
                  alt="blog-main"
                />
                <p>
                  <b>{{ "Store Owner (You):" | translate }}</b>
                </p>
                <p>
                  {{
                    "1. From your eStore dashboard, go to My Sales > Orders."
                      | translate
                  }}<br />
                  {{
                    "2. Click on the edit button for the Cash on Delivery Payment orders."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100"
                  src="assets/cod-5.png"
                  alt="blog-main"
                />
                <p>
                  {{
                    "3. You can view the customer details and edit the necessary information."
                      | translate
                  }}<br />
                  {{
                    "4. Click on 'Order Status', change the status to 'Approved' or 'Cancel'."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-60"
                  src="assets/cod-6.png"
                  alt="blog-main"
                />
                <p>
                  {{
                    "5. Now the order will be sent to FIV5s and the warehouse to process. An email will be sent to the customer to notify them of your action."
                      | translate
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-7 xl-60" *ngIf="article === 'article3'">
        <div class="blog-single">
          <div class="blog-box blog-details">
            <img
              class="img-fluid w-100"
              src="assets/sample-img7.jpg"
              alt="blog-main"
            />
            <div class="blog-details">
              <ul class="blog-social">
                <li class="digits">17 {{ "February" | translate }} 2023</li>
                <li>
                  <i class="fi fi-rs-user pr-2"></i>{{ "Admin" | translate }}
                </li>
                <li class="digits">{{ "General" | translate }}</li>
                <li class="digits">
                  <i class="fi fi-rr-clock-nine"></i>15 {{ "min" | translate }}
                </li>
                <!-- <li class="digits"><i class="fi fi-rr-social-network pr-2"></i>02<span>Hits</span></li> -->
                <!-- <li class="digits"><i class="fi fi-rr-comments pr-2"></i>598 Comments</li> -->
              </ul>
              <img
                class="img-fluid w-100"
                src="assets/knowledgebase/dm-6.jpg"
                alt="blog-main"
              />
              <h4>
                {{
                  "The Digital Marketing Channels for eCommerce." | translate
                }}
              </h4>
              <p class="mt-0">
                {{
                  "One thing that all successful eCommerce stores have in common is how they incorporate all of these channels into their marketing strategy."
                    | translate
                }}
              </p>
              <div class="single-blog-content-top">
                <b
                  ><p>
                    {{ "1. Search Engine Optimization (SEO)" | translate }}
                  </p></b
                >
                <p class="mt-2">
                  {{ "Why use SEO?" | translate }}<br />
                  {{
                    "SEO stands for Search Engine Optimization, and it is the process of optimizing a website's technical configuration, content relevance, and link popularity so that its pages are easier to find, more relevant, and more popular towards user search queries, and as a result, search engines rank them higher."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "What are organic search results and how do they relate to SEO?"
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "Organic search results are the unpaid listings that appear on a search engine results page (SERP). These results are determined by factors such as relevance to the user's search query, incoming links, valid search engine optimization (SEO) efforts, and domain authority. As opposed to paid search results, which are also known as pay-per-click advertising, organic search results are free from advertisements. Advertisers are unable to buy organic search results."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100"
                  src="assets/knowledgebase/dm-1.png"
                  alt="blog-main"
                />
                <br />
                <p>
                  <b>
                    {{ "2. Search Engine Marketing (SEM)" | translate }}<br />
                  </b>
                </p>
                <p class="mt-2">
                  {{
                    "Search engine marketing is the practice of marketing a business through paid advertisements that appear on search engine results pages (or SERPs). Advertisers bid on keywords that users of search engines like Google and Bing may enter when looking for specific products or services, giving the advertizer the opportunity for their ads to appear alongside results for those search queries."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "Is it absolutely necessary to have both SEM and SEO? No. But will implementing both result in significantly more leads and sales? Absolutely yes."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "Google Adwords is a great way to target search queries on Google.com and it is one of the leading paid search channels that retailers should be utilizing."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100 mt-2"
                  src="assets/knowledgebase/dm-2.png"
                  alt="blog-main"
                />
                <p>
                  <b>{{ "3. Email Marketing" | translate }}</b>
                </p>
                <p class="mt-2">
                  {{
                    "Email is not a dying form of communication. We are simply using it differently. It remains one of the most effective digital marketing channels for retailers in terms of return on investment (ROI)."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "Email marketing serves as a powerful channel for direct marketing and digital marketing to promote your business’s products or services. By integrating it into your marketing automation efforts, it can help make your customers aware of your latest items or offers. It can lead generation, brand awareness, building relationships or keeping customers engaged between purchases through different types of marketing emails."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{ "For Example :" | translate }}
                </p>
                <p class="mt-0">
                  {{
                    "Abandoned Cart Emails: This claim is supported by statistics. Sending three abandoned cart emails results in 69% more orders than a single email (Source: Omnisend, 2018). This is one of the most effective types of eCommerce email for boosting revenue."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100 mt-2"
                  src="assets/knowledgebase/dm-3.png"
                  alt="blog-main"
                />
                <p class="mt-0">
                  {{
                    "https://www.oberlo.com/blog/email-marketing-statistics"
                      | translate
                  }}
                </p>
                <p>
                  <b>{{ "4. Content Marketing" | translate }}</b>
                </p>
                <p class="mt-2">
                  {{
                    "As an online retailer, you cannot just focus on selling. You must provide value to customers without requiring them to make a purchase. This is where content marketing comes to play."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "Content marketing is the development and distribution of relevant, useful content to existing and potential customers, such as blogs, newsletters, white papers, social media posts, emails, videos, and the like. When it’s done right, this content conveys expertise and demonstrates that a company values the people to whom it sells."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "When your pages and website have more content, the number of users will increase. Content marketing is expected to grow from 2021 to 2025."
                      | translate
                  }}
                </p>
                <img
                  class="img-fluid w-100 mt-2"
                  src="assets/knowledgebase/dm-4.png"
                  alt="blog-main"
                />
                <p>
                  <b>{{ "5. Social Media Marketing" | translate }}</b>
                </p>
                <p class="mt-2">
                  {{
                    "Social media marketing (SMM) is an effective way for businesses of all sizes to reach out to prospects and customers. People discover, learn about, follow, and shop from brands on social media, so if you’re not on platforms like Facebook, Instagram, and LinkedIn, you’re definitely missing out! Great SMM can propel your business to new heights, fostering loyal brand advocates or even driving leads and sales."
                      | translate
                  }}
                </p>
                <p class="mt-2">
                  {{
                    "SMM Action Plan: The more targeted your SMM strategy, the greater its effectiveness. Hootsuite, a leading social media management software provider, suggests the following action plan for developing an SMM campaign with an execution framework and performance metrics:"
                      | translate
                  }}
                </p>
                <div class="mt-2">
                  <ul class="pl-4">
                    <li class="list-disc">
                      <p class="mt-0">
                        {{
                          "Align SMM goals to clear business objectives"
                            | translate
                        }}
                      </p>
                    </li>
                    <li class="list-disc">
                      <p class="mt-0">
                        {{
                          "Learn who your target customer is (age, location, income, job title, industry, interests)"
                            | translate
                        }}
                      </p>
                    </li>
                    <li class="list-disc">
                      <p class="mt-0">
                        {{
                          "Conduct a competitive analysis of your competitors (successes and failures)"
                            | translate
                        }}
                      </p>
                    </li>
                    <li class="list-disc">
                      <p class="mt-0">
                        {{
                          "Examine your current SMM (successes and failures)"
                            | translate
                        }}
                      </p>
                    </li>
                    <li class="list-disc">
                      <p class="mt-0">
                        {{
                          "Create a calendar for SMM content delivery"
                            | translate
                        }}
                      </p>
                    </li>
                    <li class="list-disc">
                      <p class="mt-0">
                        {{ "Create best-in-class content" | translate }}
                      </p>
                    </li>
                    <li class="list-disc">
                      <p class="mt-0">
                        {{
                          "Monitor performance and make adjustment to your SMM strategy as needed"
                            | translate
                        }}
                      </p>
                    </li>
                  </ul>
                </div>
                <img
                class="img-fluid w-100 mt-2"
                src="assets/knowledgebase/dm-5.png"
                alt="blog-main"
              />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-7 xl-60" *ngIf="article === 'article4'">
        <div class="blog-single">
          <div class="blog-box blog-details">
            <img
              class="img-fluid w-100"
              src="assets/sample-img8.jpg"
              alt="blog-main"
            />
            <div class="blog-details">
              <ul class="blog-social">
                <li class="digits">17 {{ "Febuary" | translate }} 2023</li>
                <li>
                  <i class="fi fi-rs-user pr-2"></i>{{ "Admin" | translate }}
                </li>
                <li class="digits">{{ "General" | translate }}</li>
                <li class="digits">
                  <i class="fi fi-rr-clock-nine"></i>1 {{ "min" | translate }}
                </li>
              </ul>
              <h4>
                {{
                  "Express checkout"
                    | translate
                }}
              </h4>
              <div class="single-blog-content-top">
                <p>
                  {{
                    "Express checkout is a way to create a convenient checkout experience for your customers. When you create an express checkout link, you can select the language, country, and products of your choice. When a customer clicks the link, it takes them to a checkout page with the selected products, where they can fill out the required information and complete the transaction."
                      | translate
                  }}
                </p>
                <p class="mt-0">
                  {{
                    "Benefits:"
                      | translate
                  }}
                </p>
              </div>
              <div class="mt-2">
                <ul class="pl-4">
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "You can embed the checkout links in webpages as regular links or buttons."
                          | translate
                      }}
                    </p>
                  </li>
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "You can share the link directly with customers for speedy checkout."
                          | translate
                      }}
                    </p>
                  </li>
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "You can share the link in any email campaigns, social media posts, chat messages, etc."
                          | translate
                      }}
                    </p>
                  </li>
                </ul>
              </div>
              <p class="mt-2">
                {{
                  "The same link is reusable and creates a new checkout for each customer."
                    | translate
                }}
              </p>
              <p class="mt-2">
                {{
                  "You can access and create Express Checkout links in the Products tab in your eStore Dashboard."
                    | translate
                }}
              </p>
              <p class="mt-2">
                {{
                  "To do so:"
                    | translate
                }}
              </p>
              <div class="mt-2">
                <ul class="pl-4">
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "In your eStore Dashboard, select"
                          | translate
                      }}
                     <b> {{
                        "Express Checkout."
                          | translate
                      }}</b>
                    </p>
                  </li>
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "Click the "
                          | translate
                      }}
                      <b>{{
                        "Create checkout link "
                          | translate
                      }}</b>
                      {{
                        "button."
                          | translate
                      }}
                    </p>
                  </li>
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "Choose your target country and language, and fill in all the mandatory fields such as products, page title, page URL, etc. accordingly."
                          | translate
                      }}
                    </p>
                  </li>
                  <li class="list-decimal">
                    <p class="mt-0">
                      {{
                        "Click the "
                          | translate
                      }}
                      <b>{{
                        "Create link "
                          | translate
                      }}</b>
                      {{
                        "button."
                          | translate
                      }}
                    </p>
                  </li>
                </ul>
              </div>
              <p class="mt-0">
                {{
                  "Once you’ve copied the express checkout link(s), you’re ready to share them anywhere or with anyone."
                    | translate
                }}
              </p>
              <p class="mt-0">
                {{
                  "Add an express checkout link to an email, your social media page, or your website or blog."
                    | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-xl-5 xl-40">
          <div class="default-according style-1 faq-accordion job-accordion" id="accordionoc">
            <div class="row">
              <div class="col-xl-12">
                <div class="card">
                  <div class="card-header" aria-controls="collapseExample">
                    <h5 class="mb-0">
                      <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-target="#collapseicon"
                        aria-expanded="true" aria-controls="collapseicon" (click)="isFindCourse = !isFindCourse"
                        [attr.aria-expanded]="!isFindCourse">Find Course <span [className]="!isFindCourse ? 'link-icon chevron down':'link-icon chevron up'"></span></button>
  
                       
                    </h5>
                  </div>
                  <div class="collapse show" id="collapseicon" aria-labelledby="collapseicon" data-parent="#accordion">
                    <div class="card-body filter-cards-view animate-chk" [ngbCollapse]="isFindCourse">
                      <div class="job-filter">
                        <div class="faq-form">
                          <input class="form-control" type="text" placeholder="Search.."><i class="search-icon"
                            data-feather="search"></i>
                        </div>
                      </div>
                      <div class="checkbox-animated">
                        <div class="learning-header"><span class="f-w-600 ff-r">Categories</span></div>
                        <label class="d-block" for="chk-ani">
                          <input class="checkbox_animated" id="chk-ani" type="checkbox"> Accounting
                        </label>
                        <label class="d-block" for="chk-ani0">
                          <input class="checkbox_animated" id="chk-ani0" type="checkbox"> Design
                        </label>
                        <label class="d-block" for="chk-ani1">
                          <input class="checkbox_animated" id="chk-ani1" type="checkbox"> Development
                        </label>
                        <label class="d-block" for="chk-ani2">
                          <input class="checkbox_animated" id="chk-ani2" type="checkbox"> Management
                        </label>
                      </div>
                      <div class="checkbox-animated mt-0">
                        <div class="learning-header"><span class="f-w-600 ff-r">Duration</span></div>
                        <label class="d-block" for="chk-ani6">
                          <input class="checkbox_animated" id="chk-ani6" type="checkbox"> 0-50 hours
                        </label>
                        <label class="d-block" for="chk-ani7">
                          <input class="checkbox_animated" id="chk-ani7" type="checkbox"> 50-100 hours
                        </label>
                        <label class="d-block" for="chk-ani8">
                          <input class="checkbox_animated" id="chk-ani8" type="checkbox"> 100+ hours
                        </label>
                      </div>
                      <div class="checkbox-animated mt-0">
                        <div class="learning-header"><span class="f-w-600 ff-r">Price</span></div>
                        <label class="d-block" for="edo-ani">
                          <input class="radio_animated" id="edo-ani" type="radio" name="rdo-ani" checked=""> All Courses
                        </label>
                        <label class="d-block" for="edo-ani1">
                          <input class="radio_animated" id="edo-ani1" type="radio" name="rdo-ani" checked=""> Paid Courses
                        </label>
                        <label class="d-block" for="edo-ani2">
                          <input class="radio_animated" id="edo-ani2" type="radio" name="rdo-ani" checked=""> Free Courses
                        </label>
                      </div>
                      <div class="checkbox-animated mt-0">
                        <div class="learning-header"><span class="f-w-600 ff-r">Status</span></div>
                        <label class="d-block" for="chk-ani3">
                          <input class="checkbox_animated" id="chk-ani3" type="checkbox"> Registration
                        </label>
                        <label class="d-block" for="chk-ani4">
                          <input class="checkbox_animated" id="chk-ani4" type="checkbox"> Progress
                        </label>
                        <label class="d-block" for="chk-ani5">
                          <input class="checkbox_animated" id="chk-ani5" type="checkbox"> Completed
                        </label>
                      </div>
                      <button class="btn btn-view text-center" type="button">Filter</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="card -20">
                  <div class="card-header">
                    <h5 class="mb-0">
                      <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-target="#collapseicon1"
                        aria-expanded="true" aria-controls="collapseicon1" (click)="isCategories = !isCategories"
                        [attr.aria-expanded]="!isCategories">Categories<span [className]="!isCategories ? 'link-icon chevron down':'link-icon chevron up'"></span></button>
                    </h5>
                  </div>
                  <div class="collapse show" id="collapseicon1" aria-labelledby="collapseicon1" data-parent="#accordion">
                    <div class="card-body filter-cards-view animate-chk p-0" [ngbCollapse]="isCategories">
                      <div class="categories">
                        <div class="learning-header"><span class="f-w-600 ff-r">Design</span></div>
                        <ul>
                          <li><a href="javascript:void(0)">UI Design </a><span
                              class="badge badge-primary pull-right">28</span></li>
                          <li><a href="javascript:void(0)">UX Design </a><span
                              class="badge badge-primary pull-right">35</span></li>
                          <li><a href="javascript:void(0)">Interface Design </a><span
                              class="badge badge-primary pull-right">17</span></li>
                          <li><a href="javascript:void(0)">User Experience </a><span
                              class="badge badge-primary pull-right">26</span></li>
                        </ul>
                      </div>
                      <div class="categories pt-0">
                        <div class="learning-header"><span class="f-w-600 ff-r">Development</span></div>
                        <ul>
                          <li><a href="javascript:void(0)">Frontend Development</a><span
                              class="badge badge-primary pull-right">48</span></li>
                          <li><a href="javascript:void(0)">Backend Development</a><span
                              class="badge badge-primary pull-right">19</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-12">
                <div class="card">
                  <div class="card-header">
                    <h5 class="mb-0">
                      <button class="btn btn-link ps-0" data-bs-toggle="collapse" data-target="#collapseicon2"
                        aria-expanded="true" aria-controls="collapseicon2" (click)="isUpcomingCourses = !isUpcomingCourses"
                        [attr.aria-expanded]="!isUpcomingCourses">Upcoming Courses<span [className]="!isUpcomingCourses ? 'link-icon chevron down':'link-icon chevron up'"></span></button>
                    </h5>
                  </div>
                  <div class="collapse show" id="collapseicon2" aria-labelledby="collapseicon2" data-parent="#accordion">
                    <div class="upcoming-course card-body" [ngbCollapse]="isUpcomingCourses">
                      <div class="media pb-3">
                        <div class="media-body"><span class="f-w-600 ff-r">UX Development</span><span class="d-block">Course By
                            <a href="javascript:void(0)"> Lorem ipsum</a></span><span class="d-block"><i
                              class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                              class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                              class="fi fi-rr-star-half-o font-warning"></i></span></div>
                        <div>
                          <h5 class="mb-0 font-primary">18</h5><span class="d-block">Dec</span>
                        </div>
                      </div>
                      <div class="media pb-3">
                        <div class="media-body"><span class="f-w-600 ff-r">Business Analyst</span><span class="d-block">Course By
                            <a href="javascript:void(0)">Lorem ipsum </a></span><span class="d-block"><i
                              class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                              class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                              class="fi fi-rr-star font-warning"></i></span></div>
                        <div>
                          <h5 class="mb-0 font-primary">28</h5><span class="d-block">Dec</span>
                        </div>
                      </div>
                      <div class="media">
                        <div class="media-body"><span class="f-w-600 ff-r">Web Development</span><span class="d-block">Course By
                            <a href="javascript:void(0)">Lorem ipsum </a></span><span class="d-block"><i
                              class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                              class="fi fi-rr-star font-warning"></i><i class="fi fi-rr-star font-warning"></i><i
                              class="fi fi-rr-star-o font-warning"></i></span></div>
                        <div>
                          <h5 class="mb-0 font-primary">5</h5><span class="d-block">Jan</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
    </div>
  </div>
</div>
